export function getCalendarGridHeaderCellId(rootId, columnIndex) {
  if (rootId === undefined) {
    return undefined;
  }
  return `${rootId}-header-cell-${columnIndex}`;
}